import { render, staticRenderFns } from "./dingtalkUser.vue?vue&type=template&id=7963871a"
import script from "./dingtalkUser.vue?vue&type=script&lang=js"
export * from "./dingtalkUser.vue?vue&type=script&lang=js"
import style0 from "./dingtalkUser.vue?vue&type=style&index=0&id=7963871a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports